// extracted by mini-css-extract-plugin
export default {"link":"ImageItem_link__iwS5m","weight":"ImageItem_weight__zXwns","buttons":"ImageItem_buttons__Z9n6m","button":"ImageItem_button__PRBVb","orderButton":"ImageItem_orderButton__ajQ73"};